import {Directive, EventEmitter, Output} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[formControlName][creditCard]',
  host: {
    '(ngModelChange)': 'onInputChange($event)',
    '(keydown.backspace)': 'onInputChange($event.target.value, true)'
  }
})
export class CreditCardDirective {

  @Output()
  rawChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(public model: NgControl) {
  }

  onInputChange(event, backspace) {
    // remove all mask characters (keep only numeric)
    let newVal = event.replace(/\D/g, '');
    let rawValue = newVal;
    // special handling of backspace necessary otherwise
    // deleting of non-numeric characters is not recognized
    // this laves room for improvment for example if you delete in the
    // middle of the string
    if (backspace) {
      if (3 >= newVal.length) {
        newVal = newVal.substring(0, newVal.length - 1);
      } else {
        newVal = newVal.substring(0, newVal.length);
      }
    }

    if (0 === newVal.length) {
      newVal = '';
    } else if (newVal.length <= 4) {
      newVal = newVal.replace(/^(\d{0,4})/, '$1');
    } else if (newVal.length <= 8) {
      newVal = newVal.replace(/^(\d{0,4})(\d{0,4})/, '$1 $2');
    } else if (newVal.length <= 12) {
      newVal = newVal.replace(/^(\d{0,4})(\d{0,4})(\d{0,4})/, '$1 $2 $3');
    } else if (newVal.length <= 16) {
      newVal = newVal.replace(/^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/, '$1 $2 $3 $4');
    } else {
      newVal = newVal.substring(0, newVal.length - 1).replace(/^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/, '$1 $2 $3 $4');
      rawValue = newVal.replace(/\D/g, '');
      console.log('DELETING LAST VALUE FOR RAW ', rawValue);
    }

    // set the new value
    this.model.valueAccessor.writeValue(newVal);
    this.rawChange.emit(rawValue);
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/directives/credit-card.directive.ts